import PaperXmlToSaltDefault from'./PaperXmlToSalt';export const PaperXmlToSalt=PaperXmlToSaltDefault;